export const getConsentModel = () =>
  window.OneTrust.GetDomainData().ConsentModel.Name;
